import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchTestCaseResults = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=search&companyid=${user.companyid}&testcaseid=${id}`,
  );

  return response.data;
};

const useTestCaseResultsQuery = (id, options) => {
  return useQuery({
    queryKey: ["testCaseResults", id],
    queryFn: () => fetchTestCaseResults(id),
    enabled: options.enabled && !!id,
    retry: true,
    // refetchInterval: 5000,

    select: (data) => {
      return {
        ...data,
        data: Object.values(data.data),
      };
    },
  });
};

export default useTestCaseResultsQuery;
